import React from 'react';
import { SchedulerStatus as ISchedulerStatus } from '../api/client';

interface Props {
  status: ISchedulerStatus;
  onTrigger: () => void;
  triggering: boolean;
}

const IconPlay = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <polygon points="5 3 19 12 5 21 5 3"/>
  </svg>
);

const IconClock = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/>
  </svg>
);

const SchedulerStatus: React.FC<Props> = ({ status, onTrigger, triggering }) => {
  const statusDot = status.isRunning ? '#10b981' : status.enabled ? '#3b82f6' : '#94a3b8';
  const statusLabel = status.isRunning ? 'Running' : status.enabled ? 'Active' : 'Disabled';
  const statusBg = status.isRunning ? '#d1fae5' : status.enabled ? '#dbeafe' : '#f1f5f9';
  const statusText = status.isRunning ? '#059669' : status.enabled ? '#2563eb' : '#6b7280';

  return (
    <div className="card" style={{ padding: '18px 20px', marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1, minWidth: 0 }}>
        {/* Pulse dot */}
        <div style={{ position: 'relative', flexShrink: 0 }}>
          <div style={{ width: 12, height: 12, borderRadius: '50%', background: statusDot }} />
          {status.isRunning && (
            <div style={{
              position: 'absolute', inset: -3,
              borderRadius: '50%',
              border: `2px solid ${statusDot}`,
              opacity: .5,
              animation: 'pulse 1.5s ease-in-out infinite',
            }} />
          )}
        </div>

        <div style={{ minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
            <span style={{ fontWeight: 700, fontSize: '14px', color: 'var(--text)' }}>Email Scheduler</span>
            <span className="badge" style={{ background: statusBg, color: statusText }}>
              {statusLabel}
            </span>
          </div>
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
            <span style={{ fontSize: '12px', color: 'var(--text-3)', display: 'flex', alignItems: 'center', gap: '4px' }}>
              <IconClock />
              <code style={{ background: '#f1f5f9', padding: '1px 6px', borderRadius: '4px', fontSize: '11px' }}>{status.cron}</code>
            </span>
            {status.lastRunAt && (
              <span style={{ fontSize: '12px', color: 'var(--text-3)' }}>
                Last: {new Date(status.lastRunAt).toLocaleString()}
              </span>
            )}
            {status.nextRunAt && !status.isRunning && (
              <span style={{ fontSize: '12px', color: 'var(--text-3)' }}>
                Next: {new Date(status.nextRunAt).toLocaleString()}
              </span>
            )}
          </div>
        </div>
      </div>

      <button
        className="btn-primary"
        onClick={onTrigger}
        disabled={triggering || status.isRunning}
      >
        {triggering ? (
          <>
            <span className="anim-spin" style={{ display: 'inline-block', width: 12, height: 12, border: '2px solid rgba(255,255,255,.3)', borderTopColor: '#fff', borderRadius: '50%' }} />
            Starting…
          </>
        ) : (
          <>
            <IconPlay />
            Run Now
          </>
        )}
      </button>
    </div>
  );
};

export default SchedulerStatus;
